/*
 * Header on scroll, like outfitters.com.pk (styles: assets/component-header-scroll.css):
 * - scrolling down hides the header
 * - scrolling up shows it again, solid white with black text/icons
 * - back at the top of the page it returns to its normal look (transparent on the homepage)
 * Only runs where the header group is fixed to the top; elsewhere the header simply scrolls with the page.
 */
(function () {
  var group = document.querySelector('.header-group');
  if (!group || window.getComputedStyle(group).position !== 'fixed') return;

  var TOP_ZONE = 10; // px from the top where the header keeps its normal look
  var MIN_DELTA = 6; // ignore tiny scroll jitter (mobile momentum, address bar resizing)
  var lastY = window.scrollY;
  var ticking = false;

  group.classList.add('header-group--scroll');

  function menuIsOpen() {
    return document.body.classList.contains('mobile-menu-open');
  }

  function setState(hidden, solid) {
    group.classList.toggle('header-group--hidden', hidden);
    group.classList.toggle('header-group--solid', solid);
    document.body.classList.toggle('header-is-hidden', hidden);
  }

  function update() {
    ticking = false;
    var y = Math.max(0, window.scrollY);

    // Keep the header in place while the menu drawer or search is open
    if (menuIsOpen() || document.body.classList.contains('search-bar-open')) {
      lastY = y;
      return;
    }

    if (y <= TOP_ZONE) {
      setState(false, false);
    } else if (Math.abs(y - lastY) >= MIN_DELTA) {
      var scrollingDown = y > lastY;
      // Don't hide until the header has fully scrolled past its own height
      setState(scrollingDown && y > group.offsetHeight, !scrollingDown || group.classList.contains('header-group--solid'));
    } else {
      return; // jitter: keep the current state and reference point
    }

    lastY = y;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    },
    { passive: true }
  );

  // Show the header again if it gets keyboard focus while hidden (e.g. tabbing back to it)
  group.addEventListener('focusin', function () {
    if (group.classList.contains('header-group--hidden')) setState(false, window.scrollY > TOP_ZONE);
  });

  update();
})();
